import { FC } from 'react';
import { Button, Icon, Tooltip, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useflowsProductBasketStore from '@flows/src/store/zustand/flows-products/flowsProductBasketStore';
import FinishBasketModal from '@flows/src/components/flow-products/quotes/basket/FinishBasketModal';
import { useFlowsSession } from '@flows/src/api/getFlowsSessionById';
import { useParty } from '@parties/src/features/detail/api/getParty';
import { FinishBasketPartyCreationModal } from '@flows/src/components/flow-products/quotes/basket/actions/anva-party-creation-modal/FinishBasketPartyCreationModal';

interface Props {
  sessionId: string;
}

const BasketFinishButton: FC<Props> = ({ sessionId }) => {
  const { t } = useTranslation();
  const { data: sessionData } = useFlowsSession(sessionId);
  const partyId = sessionData?.prospect?.id || '';
  const { data: partyData, isSuccess: isPartyDataSuccess } = useParty(partyId);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isPartyModalOpen,
    onClose: onPartyModalClose,
    onOpen: onPartyModalOpen,
  } = useDisclosure();

  const isBasketValidated = useflowsProductBasketStore(
    (state) => state.isBasketValidated,
  );
  const handleClick = () => {
    // is party an anva party?
    const hasAnvaRef = partyData?.external_refs?.some(
      (ref) => ref.company === 'anva',
    );
    if (hasAnvaRef) {
      onOpen();
    } else {
      onPartyModalOpen();
    }
  };

  return (
    <>
      {partyData && (
        <FinishBasketPartyCreationModal
          isOpen={isPartyModalOpen}
          party={partyData}
          onClose={onPartyModalClose}
          onFinish={onOpen}
          sessionId={sessionId}
        />
      )}
      <FinishBasketModal
        isOpen={isOpen}
        onClose={onClose}
        sessionId={sessionId}
      />
      <Tooltip
        isDisabled={isBasketValidated}
        label={t('FLOWS_PRODUCTS_BASKET_ACTIONS_NOT-VALID_TOOLTIP')}
      >
        <Button
          isDisabled={!isBasketValidated && isPartyDataSuccess}
          onClick={handleClick}
          rightIcon={<Icon name="GeneralActionsArrowRight" />}
        >
          {t('FINISH')}
        </Button>
      </Tooltip>
    </>
  );
};

export default BasketFinishButton;
